import * as React from "react";
import * as util from "../../../util/api";
import * as selectors from "../../../util/selectors";
import { setLoadOrder } from "../../../actions/loadOrder";
import { CollectionGenerateError, CollectionParseError, } from "../types/collections";
import { genCollectionLoadOrder } from "../util";
import LoadOrderCollections from "../views/LoadOrderCollections";
export async function generate(api, state, gameId, stagingPath, modIds, mods) {
    const profileId = selectors.lastActiveProfileForGame(state, gameId);
    if (profileId === undefined) {
        return Promise.reject(new CollectionGenerateError("Invalid profile id"));
    }
    const loadOrder = util.getSafe(state, ["persistent", "loadOrder", profileId], undefined);
    if (loadOrder === undefined) {
        // This is theoretically "fine" - the user may have simply
        //  downloaded the mods and immediately created the collection
        //  without actually setting up a load order. Alternatively
        //  the game extension itself might be handling the presort functionality
        //  erroneously. Regardless, the collection creation shouldn't be blocked
        //  by the inexistance of a loadOrder.
        return Promise.resolve(undefined);
    }
    const includedMods = modIds.reduce((accum, iter) => {
        if (mods[iter] !== undefined) {
            accum[iter] = mods[iter];
        }
        return accum;
    }, {});
    const filteredLO = genCollectionLoadOrder(loadOrder, includedMods);
    return Promise.resolve({ loadOrder: filteredLO });
}
export async function parser(api, gameId, collection) {
    const state = api.getState();
    const profileId = selectors.lastActiveProfileForGame(state, gameId);
    if (profileId === undefined) {
        return Promise.reject(new CollectionParseError(collection, "Invalid profile id"));
    }
    api.store.dispatch(setLoadOrder(profileId, collection.loadOrder));
    return Promise.resolve(undefined);
}
export function Interface(props) {
    return React.createElement(LoadOrderCollections, props, []);
}
